import { CreateAccommodationDto } from "../models/Accommodation";
import { axiosInstance } from "./AxiosDefaults";

export const getAllAccommodations = (): Promise<any> => {
  return axiosInstance.get(
    //TODO: izmeniti da dobija smestaje iz liste svih dogadjaja
    "/accommodations",
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const getAccommodation = (id: string): Promise<any> => {
  return axiosInstance.get(`${`/accommodations`}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const createAccommodation = (
  accommodation: CreateAccommodationDto
): Promise<any> => {
  return axiosInstance.post("/accommodations", accommodation, {
    headers: { "Content-Type": "application/json" },
  });
};

export const updateAccommodation = async (
  id: string,
  accommodation: CreateAccommodationDto
): Promise<any> => {
  return axiosInstance.put(`${"/accommodations"}/${id}`, accommodation, {
    headers: { "Content-Type": "application/json" },
  });
};

export const deleteAccommodation = (id: string): Promise<any> => {
  return axiosInstance.delete(`${"/accommodations"}/${id}`);
};

export const getOneAccommodationShort = (id: string): Promise<any> => {
  return axiosInstance.get(`${"/accommodations"}/${id}`);
};



